$wj([23],{

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var defaultStore = {
    mruFolders: [],
    isInitialized: false,
};
exports.getStore = satcheljs_1.createStore('mruFolderCache', defaultStore);
var store = exports.getStore();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = __webpack_require__(6);
var getMoveToMruList_1 = __webpack_require__(1841);
exports.getMoveToMruList = getMoveToMruList_1.default;
owa_bundling_1.preloadScriptChunk('MoveMruActions');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2264));
});
exports.lazyAddFolderIdToMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.addFolderIdToMoveToMruList; });
exports.lazyRemoveFolderIdFromMoveToMruList = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFolderIdFromMoveToMruList; });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationService_1 = __webpack_require__(1842);
var store_1 = __webpack_require__(1711);
var folderNameToId_1 = __webpack_require__(35);
var legacy_1 = __webpack_require__(1);
/**
 * Action to get Move to Mru list
 */
exports.default = legacy_1.action('getMoveToMruList')(function getMoveToMruList() {
    getFolderMruConfigurationService_1.default().then(function (response) { return processResponse(response); });
});
// Process TargetFolderMruConfiguration
function processResponse(response) {
    if (response.FolderMruEntries == null || response.FolderMruEntries.length == 0) {
        store_1.default.mruFolders.push(folderNameToId_1.default('inbox'));
        store_1.default.mruFolders.push(folderNameToId_1.default('deleteditems'));
        store_1.default.mruFolders.push(folderNameToId_1.default('archive'));
    }
    else {
        for (var i = 0; i < response.FolderMruEntries.length; i++) {
            var folderId = response.FolderMruEntries[i].EwsFolderIdEntry;
            store_1.default.mruFolders.push(folderId);
        }
    }
    store_1.default.isInitialized = true;
}
//# sourceMappingURL=getMoveToMruList.js.map

/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationOperation_1 = __webpack_require__(1843);
/**
 * Action to get folder MRU Configuration
 * @return the TargetFolderMruConfiguration
 */
function getFolderMruConfigurationService() {
    return getFolderMruConfigurationOperation_1.default().then(function (response) {
        return response;
    });
}
exports.default = getFolderMruConfigurationService;
//# sourceMappingURL=getFolderMruConfigurationService.js.map

/***/ }),

/***/ 1843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
function getFolderMruConfigurationOperation(options) {
    return ServiceRequest_1.makeServiceRequest("GetFolderMruConfiguration", {}, options);
}
exports.default = getFolderMruConfigurationOperation;


/***/ }),

/***/ 1909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var deleteFolderInFolderForest_1 = __webpack_require__(4730);
exports.deleteFolderInFolderForest = deleteFolderInFolderForest_1.default;
var selectPersona_1 = __webpack_require__(4737);
exports.selectPersona = selectPersona_1.default;
var toggleFavoriteFolder_1 = __webpack_require__(4738);
exports.toggleFavoriteFolder = toggleFavoriteFolder_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
exports.folderTableSelector = {
    folderTable: function () { return Store_1.default.folders.folderTable; },
};
/** Returns true if a folder is specified distinguished folder. */
function isDistinguishedFolder(folder, distinguishedFolderId) {
    // folder is null in search scenario
    return !!folder && folder.distinguishedFolderId == distinguishedFolderId;
}
exports.isDistinguishedFolder = isDistinguishedFolder;
/** Returns true if a folder is a subfolder of a specified distinguished folder. */
function isSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    // folder is null in search scenario
    var parentFolderId = !!folder && folder.ParentFolderId;
    if (!parentFolderId) {
        // The parentFolderId is null for msgfolderroot, which means it's not a subfolder
        return false;
    }
    var parentFolder = state.folderTable.get(parentFolderId.Id);
    while (parentFolder) {
        if (parentFolder.distinguishedFolderId == distinguishedFolderId) {
            return true;
        }
        else if (!parentFolder.ParentFolderId) {
            return false;
        }
        parentFolder = state.folderTable.get(parentFolder.ParentFolderId.Id);
    }
    return false;
}
exports.isSubFolderOfDistinguishedFolder = isSubFolderOfDistinguishedFolder;
exports.isUnderDistinguishedFolder = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(isSubFolderOfDistinguishedFolder);
/** Returns true if a folder is a specified distinguished folder or is a subfolder of it.*/
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderOrSubFolderOfDistinguishedFolder(folder, distinguishedFolderId, state) {
    return (isDistinguishedFolder(folder, distinguishedFolderId) ||
        exports.isUnderDistinguishedFolder(folder, distinguishedFolderId, state));
});
//# sourceMappingURL=isFolderOrSubFolderOfDistinguishedFolder.js.map

/***/ }),

/***/ 3169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
var isFolderOrSubFolderOfDistinguishedFolder_1 = __webpack_require__(2226);
exports.default = legacy_1.select({
    folderTable: function () { return Store_1.default.folders.folderTable; },
})(function isFolderUnderDeletedFolder(folder, state) {
    return isFolderOrSubFolderOfDistinguishedFolder_1.isUnderDistinguishedFolder(folder, 'deleteditems', state);
});
//# sourceMappingURL=isFolderUnderDeletedFolder.js.map

/***/ }),

/***/ 4730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var selectFolder_1 = __webpack_require__(386);
var owa_confirm_dialog_1 = __webpack_require__(223);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_mail_favorites_store_2 = __webpack_require__(32);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var owa_mail_folder_store_1 = __webpack_require__(606);
var deleteFolder_1 = __webpack_require__(4731);
var owa_mail_move_mru_1 = __webpack_require__(1840);
var Store_1 = __webpack_require__(17);
var isFolderUnderDeletedFolder_1 = __webpack_require__(3169);
var folderNameToId_1 = __webpack_require__(35);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
/**
 * Called on folders deleted
 * @param folderIds the folder ids that have been deleted
 * @param state the state which contains the favorite ids
 */
exports.default = legacy_1.action('deleteFolderInFolderForest')(legacy_1.select({
    favoritesFolderNodes: function () { return owa_mail_favorites_store_2.favoritesStore.favoritesFolderNodes; },
    folders: function () { return Store_1.default.folders; },
})(function deleteFolderInFolderForest(folderId, actionSource, state) {
    var _this = this;
    var favoritesFolderNodes = state.favoritesFolderNodes, folders = state.folders;
    var folderIdsToDelete = owa_mail_folder_store_1.getAllSubFolderIds(folderId);
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    // TODO: VSO 8717: Show a different dialog when deleting a folder when folder with the same name exists under deleted items folder
    // TODO: VSO 11474: Fix delete scenario for public folder and archive delted items folder
    // If the item is in the deleted items folder or in PublicFolder or in archived deleted items folder, perform a softdelete.
    var isFolderUnderDeletedItemFolder = isFolderUnderDeletedFolder_1.default(folderToDelete);
    var confirmationSubText = isFolderUnderDeletedItemFolder
        ? owa_mail_strings_1.default.confirmPermanentDeleteFolderSubText
        : owa_mail_strings_1.default.confirmDeleteFolderSubText;
    // Popout the confirmation dialog
    owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.confirmDeleteFolderText, owa_strings_1.format(confirmationSubText, folderToDelete.DisplayName)).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                folderIdsToDelete.forEach(function (id) {
                    // Try remove the folder id from the favorites if it's in favorites
                    tryRemoveFromFavorites(id, favoritesFolderNodes, actionSource);
                    // Reset selection to inbox if we are deleting selected folder or if it is a part of subtree being deleted
                    if (id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
                        selectFolder_1.default(folderNameToId_1.default('inbox'), 'primaryFolderTree' /* treeType */);
                    }
                });
                // Remove the folder from the folder store and sends out deleteFolder service request
                return [2 /*return*/, deleteFolder_1.default(folders, folderId, isFolderUnderDeletedItemFolder /* softDelete */)];
            }
            return [2 /*return*/];
        });
    }); });
    // Update move to folder mru list
    owa_mail_move_mru_1.lazyRemoveFolderIdFromMoveToMruList.importAndExecute(folderId);
}));
/**
 * Try remove the id from favorite folder ids if it's in the list
 * @param folderIds the folder ids that have been deleted
 * @param favoritesFolderNodes the favorite nodes
 */
function tryRemoveFromFavorites(idToRemove, favoritesFolderNodes, actionSource) {
    if (favoritesFolderNodes.has(idToRemove)) {
        owa_mail_favorites_store_1.lazyRemoveFavoriteFolder.importAndExecute(idToRemove, actionSource);
    }
}
//# sourceMappingURL=deleteFolderInFolderForest.js.map

/***/ }),

/***/ 4731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getAllSubFolderIds_1 = __webpack_require__(803);
var localFolderOperations_1 = __webpack_require__(648);
var actionTypes_1 = __webpack_require__(74);
var deleteFolderService_1 = __webpack_require__(4732);
var undoActions = __webpack_require__(214);
var owa_service_error_1 = __webpack_require__(152);
var folderNameToId_1 = __webpack_require__(35);
var owa_strings_1 = __webpack_require__(20);
var owa_mail_strings_1 = __webpack_require__(22);
var legacy_1 = __webpack_require__(1);
var stitch_1 = __webpack_require__(44);
function deleteFoldersFromFolderTable(state, folderIdsToDelete) {
    // delete each folder from local store
    folderIdsToDelete.forEach(function (folderId) {
        state.folderTable.delete(folderId);
    });
}
exports.deleteFoldersFromFolderTable = deleteFoldersFromFolderTable;
exports.default = legacy_1.action('deleteFolder')(function deleteFolder(folders, folderId, softDelete) {
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    undoActions.clearLastUndoableAction();
    localFolderOperations_1.removeFolderFromParentFolder(folders, folderToDelete);
    var folderIdsToDelete = getAllSubFolderIds_1.default(folderToDelete.FolderId.Id);
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError('deleteFolderWithoutConfirmation', owa_strings_1.format(owa_mail_strings_1.default.errorDeletingFolder, folderToDelete.DisplayName), function () {
        return deleteFolderService_1.default(folderId, softDelete);
    });
    // raise the stitch to notify list view component to update the list view store
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteFolderAction)(folderIdsToDelete);
    if (softDelete) {
        // If the item is in the deleted items folder or in PublicFolder or in archived deleted items folder, perform a softdelete.
        deleteFoldersFromFolderTable(folders, folderIdsToDelete);
    }
    else {
        var deletedItemsFolderId = folderNameToId_1.default('deleteditems');
        localFolderOperations_1.moveFolderToParentFolder(folders, folderToDelete, deletedItemsFolderId);
    }
    return actionResponse;
});
//# sourceMappingURL=deleteFolder.js.map

/***/ }),

/***/ 4732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequestUtils_1 = __webpack_require__(31);
var deleteFolderOperation_1 = __webpack_require__(796);
var folderId_1 = __webpack_require__(47);
var deleteFolderRequest_1 = __webpack_require__(795);
function deleteFolderService(deleteFolderId, permanentlyDelete) {
    return deleteFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: deleteFolderRequest_1.default({
            DeleteType: permanentlyDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            FolderIds: [folderId_1.default({ Id: deleteFolderId })],
        }),
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = deleteFolderService;
//# sourceMappingURL=deleteFolderService.js.map

/***/ }),

/***/ 4737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(127);
var selectDefaultFolder_1 = __webpack_require__(398);
var selectNodeInFolderForest_1 = __webpack_require__(170);
var onAfterSelectingNode_1 = __webpack_require__(253);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var legacy_1 = __webpack_require__(1);
/**
 * Select a persona node
 * @param personaId the folderId
 * @return a promise that resolves when the load persona table from server has completed
 */
exports.default = legacy_1.action('selectPersona', datapoints_1.default.selectPersona)(function selectPersona(personaId) {
    var selectNodePromise;
    // Only perform the rest of selecting folder logic when
    // user navigates to a folder with the different folderId
    if (personaId != owa_mail_folder_forest_store_1.getSelectedNode().id) {
        var persona = owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.get(personaId);
        if (!persona) {
            selectDefaultFolder_1.default();
            return Promise.resolve();
        }
        selectNodePromise = selectNodeInFolderForest_1.default(persona);
        owa_mail_favorites_store_1.lazyOnFavoritePersonaSelected.importAndExecute(persona.id);
    }
    // Called after selecting same/different persona
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode_1.default();
    return selectNodePromise;
});
//# sourceMappingURL=selectPersona.js.map

/***/ }),

/***/ 4738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var selectFolder_1 = __webpack_require__(386);
var favorites = __webpack_require__(32);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var owa_mail_persona_search_folder_services_1 = __webpack_require__(163);
var folderNameToId_1 = __webpack_require__(35);
var legacy_1 = __webpack_require__(1);
/**
 * Toggle favorite state of a node
 * @param folder the folder
 */
exports.default = legacy_1.action('toggleFavoriteFolder')(function toggleFavoriteFolder(folder, actionSource) {
    var personaId = owa_mail_persona_search_folder_services_1.getPersonaIdFromExtendedProperty(folder);
    var favoriteId = personaId || folder.FolderId.Id;
    if (favorites.isFolderInFavorites(favoriteId)) {
        // Reset the folder selection to inbox if unfavorite a selected node
        if (favoriteId == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
            selectFolder_1.default(folderNameToId_1.default('inbox'), 'primaryFolderTree' /* treeType */);
        }
        favorites.lazyRemoveFavoriteFolder.importAndExecute(favoriteId, actionSource);
    }
    else {
        favorites.lazyAddFavoriteFolder.importAndExecute(favoriteId, actionSource);
    }
});
//# sourceMappingURL=toggleFavoriteFolder.js.map

/***/ })

});


// WEBPACK FOOTER //
// owa.FolderForestActions.js